import polyglotI18nProvider from "ra-i18n-polyglot"
import defaultMessages from "ra-language-english"

export const i18nProvider = polyglotI18nProvider(
  () => defaultMessages,
  "en",
  [{ name: "en", value: "English" }],
  { allowMissing: true }
)
